import { NodePosition, OrgChartRow } from "./organization-chart";

export class SvgRenderer
{
    static drawConnectingLines(svg: SVGElement, nodePositions: Map<string, NodePosition>, filteredData: OrgChartRow[]): void
    {
        svg.innerHTML = "";

        filteredData.forEach(row =>
        {
            const nodeId = row.Node.Value;
            const managerId = row.ManagerId;

            if (managerId && nodePositions.has(nodeId) && nodePositions.has(managerId))
            {
                const childPos = nodePositions.get(nodeId);
                const parentPos = nodePositions.get(managerId);

                this.createConnectingLine(svg, parentPos, childPos);
            }
        });
    }

    static collectNodePositions(svg: SVGElement): Map<string, NodePosition>
    {
        const nodePositions = new Map<string, NodePosition>();
        const nodes = document.querySelectorAll(".horizontal-org-node");

        nodes.forEach(node =>
        {
            const nodeId = node.getAttribute("data-node-id");
            if (nodeId)
            {
                const rect = node.getBoundingClientRect();
                const containerRect = svg.getBoundingClientRect();

                nodePositions.set(nodeId, {
                    x: rect.left - containerRect.left + rect.width / 2,
                    y: rect.top - containerRect.top + rect.height / 2,
                    width: rect.width,
                    height: rect.height
                });
            }
        });

        return nodePositions;
    }

    private static createConnectingLine(svg: SVGElement, parentPos: NodePosition, childPos: NodePosition): void
    {
        const line = document.createElementNS("http://www.w3.org/2000/svg", "path");

        const parentRight = parentPos.x + parentPos.width / 2;
        const parentY = parentPos.y;
        const childLeft = childPos.x - childPos.width / 2;
        const childY = childPos.y;

        const midX = parentRight + (childLeft - parentRight) / 2;
        const pathData = `M ${parentRight} ${parentY} L ${midX} ${parentY} L ${midX} ${childY} L ${childLeft} ${childY}`;

        line.setAttribute("d", pathData);
        line.setAttribute("stroke", "#666666");
        line.setAttribute("stroke-width", "2");
        line.setAttribute("fill", "none");
        line.setAttribute("stroke-linecap", "round");

        svg.appendChild(line);
    }
}
